export var ACTION;
(function (ACTION) {
    ACTION["ON_TRACK_PENDING_CUSTOMER_JOURNEY"] = "ON_TRACK_PENDING_CUSTOMER_JOURNEY";
    ACTION["SHARE_PENDING_CUSTOMER_LINK"] = "SHARE_PENDING_CUSTOMER_LINK";
    ACTION["NAVIAGTE_TO_LEAD_SCREEN"] = "NAVIAGTE_TO_LEAD_SCREEN";
})(ACTION || (ACTION = {}));
